import { render } from "./calcSetting.vue?vue&type=template&id=0f1b8a7c&scoped=true"
import script from "./calcSetting.vue?vue&type=script&lang=js"
export * from "./calcSetting.vue?vue&type=script&lang=js"

import "./calcSetting.vue?vue&type=style&index=0&id=0f1b8a7c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f1b8a7c"]])

export default __exports__